/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Group_Story_EmptyInputs */

const vi_shop_group_story_empty = /** @type {(inputs: Shop_Group_Story_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không có câu chuyện nào khớp.`)
};

/**

* @param {Shop_Group_Story_EmptyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_group_story_empty = /** @type {((inputs?: Shop_Group_Story_EmptyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Group_Story_EmptyInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_group_story_empty(inputs)
});